/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */
import type { CreateDiagnosticProcedureDtoCategoryOfTest } from './createDiagnosticProcedureDtoCategoryOfTest';

export interface CreateDiagnosticProcedureDto {
  /** Category of test */
  categoryOfTest?: CreateDiagnosticProcedureDtoCategoryOfTest;
  /** Extra test information */
  extraTestInformation?: string;
  /** Number of positive tests */
  numberOfPositiveTests?: number;
  /** Number of negative tests */
  numberOfNegativeTests?: number;
  /** Total number of tests */
  numberOfTests?: number;
  /** Sample type code */
  sampleTypeCode?: string;
  /** Sub category code */
  subCategoryCode?: string;
  /** Family code */
  familyCode?: string;
}
